import { FunctionComponent } from "react";

import { ArrowWrapper, StyledArrow } from "./styles";

interface IProps {
  color?: string;
  size?: number;
  direction: string;
  panelTitle?: string;
}

const Arrow: FunctionComponent<IProps> = ({ color = "black", size = 20, direction, panelTitle }) => {
  return (
    <ArrowWrapper
      size={`${size}px`}
      data-testid="arrow"
      aria-expanded={direction === "up" ? "true" : "false"}
      aria-controls={panelTitle}
    >
      <StyledArrow direction={direction} color={color} size={`${Math.hypot(size / 2, size / 2)}px`} />
    </ArrowWrapper>
  );
};

export default Arrow;
